'use client'

import PropTypes from 'prop-types'
import MUIIconButton from '@mui/material/IconButton'
import { SettingsIcon } from '@repo/ui/SettingsIcon'
import { useState } from 'react'
import { Modal } from '@repo/ui/Modal'
import { useTheme } from '@mui/material/styles'

export const SettingsButtonAndPopup = ({ settingsPopup }) => {
  const [settingsPopupIsOpen, setSettingsPopupIsOpen] = useState(false)
  const theme = useTheme()
  const Component = settingsPopup

  return (
    <>
      <MUIIconButton
        data-testid="SettingsButtonAndPopup"
        onClick={() => setSettingsPopupIsOpen(true)}
        aria-label="Settings"
      >
        <SettingsIcon sx={{ color: theme.palette.primary.main, opacity: 0.56 }} />
      </MUIIconButton>

      <Modal
        open={settingsPopupIsOpen}
        handleClose={() => setSettingsPopupIsOpen(false)}
        title="Settings"
        sx={{ width: '460px' }}
      >
        {settingsPopup ? <Component cancelAction={() => setSettingsPopupIsOpen(false)} /> : null}
      </Modal>
    </>
  )
}

SettingsButtonAndPopup.propTypes = {
  settingsPopup: PropTypes.any
}
